import React from 'react';
import { Text } from '@spotify-internal/encore-web';
import { purify } from '../../lib/purify';

const LegalTerms = ({ text }: { text: string }) => {
  return (
    <Text
      as="p"
      variant="marginal"
      dangerouslySetInnerHTML={{ __html: purify(text) }}
    />
  );
};

export default LegalTerms;
